import React from "react";
import Select from "react-select";

const ReactSelect = ({
  name,
  value,
  options = [],
  onChange,
  isClearable = true,
  isSearchable = true,
  placeholder = "Select option",
}) => {

  const customStyles = {
    control: (base) => ({
      ...base,
      borderColor: "#D9D9D9",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#1976D2",
      },
      minHeight: "44px",
      borderRadius: "8px",
    }),

    option: (base, state) => ({
      ...base,
      backgroundColor: state.isSelected
        ? "#1976D2"
        : state.isFocused
          ? "#1976D270"
          : "white",
      color: state.isSelected ? "white" : "#000",
      cursor: "pointer",
    }),

    singleValue: (base) => ({
      ...base,
      color: "#1976D2",
      fontWeight: 500,
    }),

    /** ✅ THIS IS THE FIX */
    indicatorSeparator: (base) => ({
      ...base,
      backgroundColor: "#D9D9D9",
      width: "2px",
      marginTop: "8px",
      marginBottom: "8px",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      color: "#D9D9D9",
      "&:hover": { color: "#1976D2" },
    }),

    clearIndicator: (base) => ({
      ...base,
      color: "#D9D9D9",
      "&:hover": { color: "#1976D2" },
    }),
  };


  return (
    <Select
      name={name}
      value={value}
      options={options}
      onChange={(selected) =>
        onChange({
          target: {
            name,
            value: selected,
          },
        })
      }
      isClearable={isClearable}
      isSearchable={isSearchable}
      placeholder={placeholder}
      styles={customStyles}
    />
  );
};

export default ReactSelect;
